<template>

  <div>

    <v-alert
      class="mx-auto mt-16"
      width="600px"
      border="top"
      colored-border
      type="success"
      elevation="2"
    >

      <h3>
        {{ title }}
      </h3>

      <v-divider
        class="my-4 info"
        style="opacity: 0.22"
      />

      <v-row
        align="center"
        no-gutters
      >

        <v-col class="grow">

          {{ message }}

        </v-col>

      </v-row>

    </v-alert>

  </div>

</template>
<script>

export default {
  name: 'Reset-Password-Message',
  props: {
    email: {
      type: String
    }
  },
  data () {
    return {
      title: 'Password Changed!',
      message: 'Password reset successfully.'
    }
  }
}
</script>
